import store from '../../../core/store';

export const listCompanyFolders = () => {
  return store.dispatch({
    action: 'table.company_folders/LIST_COMPANY_FOLDERS',
    method: 'GET',
    endpoint: '/hr_folders',
    main: true,
  });
};

export const createCompanyFolder = (formData) => {
  return store.dispatch({
    action: 'table.company_folders/CREATE_COMPANY_FOLDERS',
    method: 'POST',
    endpoint: '/hr_folders',
    data: formData,
  });
};

export const deleteCompanyFolder = (id) => {
  return store.dispatch({
    action: 'table.company_folders/DELETE_COMPANY_FOLDERS',
    method: 'DELETE',
    endpoint: '/hr_folders/' + id,
  });
};

export const readCompanyFolder = (company_folder_id) => {
  return store.dispatch({
    action: 'table.company_folders/READ_COMPANY_FOLDER',
    method: 'GET',
    endpoint: '/hr_folders/' + company_folder_id,
  });
};

export const updateCompanyFolder = (company_folder_id, formData) => {
  return store.dispatch({
    action: 'table.company_folders/UPDATE_COMPANY_FOLDER',
    method: 'PUT',
    endpoint: '/hr_folders/' + company_folder_id,
    data: formData,
  });
};
